import { render, staticRenderFns } from "./TargetingOperatingSystem.vue?vue&type=template&id=6bb7ac84&"
import script from "./TargetingOperatingSystem.vue?vue&type=script&lang=js&"
export * from "./TargetingOperatingSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports